export enum IdeaStatus {
  NEW = 'new',
  PLANNED = 'planned',
  REJECTED = 'rejected',
  COMPLETED = 'completed',
}
